import { render } from "./BranchesIndex.vue?vue&type=template&id=77210bc4"
import script from "./BranchesIndex.vue?vue&type=script&lang=js"
export * from "./BranchesIndex.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__